module.exports = __webpack_public_path__ + "img/o0-10.d5ad39b1.jpg";